<div class="row">
  <div class="col">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Clients Surveys</li>
      </ol>
    </nav>
  </div>
</div>
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3">
  <h1 class="h2">Clients Surveys</h1>
</div>
<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col">
        <h6>Date Range</h6>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <form [formGroup]="dateForm" (ngSubmit)="dateFormOnSubmit()">
          <div class="row">
            <div class="col-sm-3 col-lg-2 col-xl-2 col-xxl-1">
              <div class="form-group my-1">
                <label for="month" class="sr-only">Month</label>
                <select id="month" class="form-control" formControlName="month">
                  <option *ngFor="let month of months" [value]="month.id">{{ month.name }}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-3 col-lg-2 col-xl-2 col-xxl-1">
              <div class="form-group my-1">
                <label for="year" class="sr-only">Year</label>
                <select id="year" class="form-control" formControlName="year">
                  <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-3 col-lg-1 d-flex align-items-end">
              <button type="submit" class="btn btn-primary my-1" [disabled]="dateForm.invalid">Search</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col survey-type-tabs">
        <ng-container *ngIf="areSurveyTypesLoading">
          <div class="loading-cover">
            <fa-icon class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> Loading
          </div>
        </ng-container>
        <ng-container *ngIf="!areSurveyTypesLoading">
          <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="activeIndex">
            <p-tabPanel *ngFor="let surveyType of surveyTypes; let i = index" [header]="surveyType.value ?? 'Unknown'">
              <app-clients-to-call-grid [surveyType]="surveyType" [activeSurveyTypeId]="activeSurveyTypeId"
                [tabIndex]="i"></app-clients-to-call-grid>
            </p-tabPanel>
          </p-tabView>
        </ng-container>

      </div>
    </div>

  </div>

</div>